var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryApplicationIntegration16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Application-Integration_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Application-Integration_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F8B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Application-Integration_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Application-Integration_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Application-Integration_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,15 L8,15 L8,13.936 C8.161,13.979 8.329,14 8.5,14 C9.603,14 10.5,13.103 10.5,12 C10.5,10.897 9.603,10 8.5,10 C8.329,10 8.161,10.021 8,10.064 L8,9 L10.39,9 C10.588,9 10.768,8.883 10.848,8.701 C10.928,8.519 10.892,8.307 10.758,8.161 C10.592,7.981 10.5,7.746 10.5,7.5 C10.5,6.949 10.948,6.5 11.5,6.5 C12.052,6.5 12.5,6.949 12.5,7.5 C12.5,7.746 12.408,7.981 12.242,8.161 C12.108,8.307 12.072,8.519 12.152,8.701 C12.232,8.883 12.412,9 12.61,9 L15,9 L15,13.5 C15,14.327 14.327,15 13.5,15 L13.5,15 Z M2.5,15 C1.673,15 1,14.327 1,13.5 L1,9 L2.063,9 C2.021,9.162 2,9.33 2,9.5 C2,10.603 2.897,11.5 4,11.5 C5.103,11.5 6,10.603 6,9.5 C6,9.33 5.979,9.162 5.937,9 L7,9 L7,10.89 C7,11.089 7.117,11.269 7.3,11.348 C7.481,11.428 7.692,11.392 7.84,11.257 C8.019,11.091 8.254,11 8.5,11 C9.052,11 9.5,11.449 9.5,12 C9.5,12.551 9.052,13 8.5,13 C8.254,13 8.019,12.909 7.84,12.743 C7.692,12.608 7.481,12.571 7.3,12.652 C7.117,12.731 7,12.911 7,13.11 L7,15 L2.5,15 Z M1,2.5 C1,1.673 1.673,1 2.5,1 L7,1 L7,2.564 C6.839,2.521 6.671,2.5 6.5,2.5 C5.397,2.5 4.5,3.397 4.5,4.5 C4.5,5.603 5.397,6.5 6.5,6.5 C6.671,6.5 6.839,6.479 7,6.436 L7,8 L5.11,8 C4.912,8 4.732,8.117 4.652,8.299 C4.572,8.481 4.608,8.693 4.742,8.839 C4.908,9.019 5,9.254 5,9.5 C5,10.051 4.552,10.5 4,10.5 C3.448,10.5 3,10.051 3,9.5 C3,9.254 3.092,9.019 3.258,8.839 C3.392,8.693 3.428,8.481 3.348,8.299 C3.268,8.117 3.088,8 2.89,8 L1,8 L1,2.5 Z M15,2.5 L15,8 L13.437,8 C13.479,7.838 13.5,7.67 13.5,7.5 C13.5,6.397 12.603,5.5 11.5,5.5 C10.397,5.5 9.5,6.397 9.5,7.5 C9.5,7.67 9.521,7.838 9.563,8 L8,8 L8,5.61 C8,5.411 7.883,5.231 7.7,5.152 C7.518,5.072 7.307,5.108 7.16,5.243 C6.981,5.409 6.746,5.5 6.5,5.5 C5.948,5.5 5.5,5.051 5.5,4.5 C5.5,3.949 5.948,3.5 6.5,3.5 C6.746,3.5 6.981,3.591 7.16,3.757 C7.306,3.891 7.517,3.927 7.7,3.848 C7.883,3.769 8,3.589 8,3.39 L8,1 L13.5,1 C14.327,1 15,1.673 15,2.5 L15,2.5 Z M13.5,0 L2.5,0 C1.121,0 0,1.122 0,2.5 L0,8 L0,9 L0,13.5 C0,14.878 1.121,16 2.5,16 L7,16 L8,16 L13.5,16 C14.879,16 16,14.878 16,13.5 L16,2.5 C16,1.122 14.879,0 13.5,0 L13.5,0 Z",
    id: "Application-Integration_Category-Icon_16_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryApplicationIntegration16);
export default __webpack_public_path__ + "static/media/Arch-Category_Application-Integration_16.6723bc9a908ad3a80e2279bd347fc574.svg";
export { ForwardRef as ReactComponent };